Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  basic_more: 'Mehr',
  app_name: 'iM Football',
  match_postponed: 'Verlegt',
  match_abandoned: 'Abgebrochen',
  home_match: 'Hinspiel',
  away_match: 'Rückspiel',
  no_start_time: 'Nicht verfügbar',
  own_goal: '(ET)',
  last_day: 'Gestern',
  tomorrow: 'morgen',
  at_date: 'am',
  teaser_date_prefix: 'Vor',
  source_prefix: 'Von',
  source_join: 'und',
  theme: 'Thema',
  minute_short: 'Min.',
  ranking_title_GOALS: 'Tore',
  ranking_title_SCORER: 'Scorer',
  ranking_title_ASSISTS: 'Assists',
  ranking_title_YELLOW_CARDS: 'Gelbe Karten',
  ranking_title_RED_CARDS: 'Rote Karten',
  ranking_header_goals: 'Tore',
  ranking_header_points: 'Pkt',
  ranking_header_assists: 'Ass',
  ranking_header_yellow_cards: 'Gelb',
  ranking_header_red_cards: 'Rot',
  years: 'Jahre',
  bet_on_tip: 'Wette jetzt ››',
  wager: 'Einsatz',
  profit: 'Gewinn',
  sponsored: 'gesponsort von',
  quote: 'Quote',
  more_than: 'Mehr als',
  less_than: 'Weniger als',
  group: 'Gruppe',
  ticker: 'Ticker',
  conference: 'Konferenz',
  line_up: 'Aufstellung',
  standings: 'Tabelle',
  statistics: 'Statistik',
  favorites: 'Favoriten',
  top_competitions: 'Top Wettbewerbe',
  all_competitions: 'Alle Wettbewerbe',
  info: 'Info',
  gameplan: 'Spielplan',
  match_day: 'Spieltag',
  round: 'Runde',
  no_events: 'Es gibt keine Veranstaltungen an diesem Tag',
  squad: 'Kader',
  ranking: 'Rankings',
  feed: 'Feed',
  position_GOALKEEPER: 'Tor',
  position_DEFENDER: 'Abwehr',
  position_MIDFIELDER: 'Mittelfeld',
  position_FORWARD: 'Angriff',
  position_TRAINER: 'Trainer',
  show_more: 'Mehr anzeigen',
  show_less: 'Weniger anzeigen',
  fetching_data_error: 'Beim Laden der Daten ist leider ein Fehler aufgetreten.',
  fetching_data_empty: 'Keine Daten vorhanden.',
  refreshing_data_error: 'Daten konnten nicht aktualisiert werden',
  formation_bench: 'Auswechselbank',
  formation_substitution: 'Spielerwechsel',
  penalty_shootout: 'Elfmeterschießen',
  standings_qualify: {
    champions_league: 'Champions League',
    champions_league_quali: 'Champions League Qualifikation',
    europa_league: 'Europa League',
    europa_league_quali: 'Europa League Qualifikation',
    europa_league_play_offs: 'Europa League Play-Offs',
    way_down_relegation: 'Abstieg Relegation',
    way_down_play_offs: 'Abstieg Play-Offs',
    way_down: 'Abstieg',
    promotion: 'Aufstieg',
    promotion_relegation: 'Aufstieg Relegation',
    promotion_play_offs: 'Aufstieg Play-Offs'
  },
  form_title: 'Form',
  form_label: 'Letzte fünf Spiele',
  form: {
    WIN: 'S',
    DRAW: 'U',
    LOST: 'N'
  },
  statistic_entries: {
    GENERAL: 'Allgemein',
    TOTAL_SHOTS_ON_TARGET: 'Schüsse aufs Tor',
    PERCENTAGE_PASS: 'Passquote',
    POSSESSION_PERCENTAGE: 'Ballbesitz',
    DISTANCE: 'Laufleistung (km)',
    TOTAL_YELLOW_CARD: 'Gelbe Karten',
    SENDING_OFF: 'Platzverweise',
    TRACKING: 'Tracking',
    SPRINTS: 'Anzahl Sprints',
    AVG_SPEED: 'Durchschnittsgeschw. (km/h)',
    OFFENSIVE: 'Offensive',
    GOALS: 'Tore',
    TOTAL_SHOTS: 'Schüsse gesamt',
    PERCENTAGE_SHOTS_ON_GOAL: 'Schussgenauigkeit',
    TOTAL_CHANCES: 'Herausgespielte Chancen',
    WON_CONTEST: 'Erfolgreiche Dribblings',
    FOULS_WON: 'Gefoult worden',
    CORNERS: 'Eckstöße',
    FREEKICK: 'Freistöße',
    TOTAL_OFFSIDES: 'Abseits',
    DEFENSIVE: 'Defensive',
    BLOCKED_PASS: 'Abgefangene Pässe',
    BLOCKED_CROSS: 'Abgefangene Flanken',
    TOTAL_CLEARANCE: 'Klärende Aktionen',
    FOULS: 'Fouls',
    GOALKEEPER: 'Torwart',
    SAVES: 'Gehaltene Bälle',
    GOOD_HIGH_CLAIM: 'Abgefangene Flanken',
    PASS: 'Passspiel',
    TOTAL_PASS: 'Pässe gesamt',
    ACCURATE_PASS: 'Angekommene Pässe',
    TOTAL_CROSS: 'Flanken',
    ACCURATE_CROSS: 'Angekommene Flanken',
    ACCURATE_CROSS_PERCENTAGE: 'Flankenquote',
    LONG_BALLS: 'Lange Pässe (über 30 Meter)',
    ACCURATE_LONG_BALLS: 'Erfolgreiche lange Pässe',
    TACKLE: 'Zweikämpfe',
    TOTAL_TACKLE: 'Zweikämpfe',
    DUEL_WON: 'Gewonnene Zweikämpfe',
    DUEL_PERCENTAGE: 'Zweikampfquote',
    AERIAL_WON: 'Gewonnene Luftduelle',
    BALL_POSSESSION: 'Ballbesitz',
    BALL_TOUCHES: 'Ballkontakte',
    BALL_LOST: 'Ballverluste'
  },
  live: 'Live',
  news: 'News',
  newsticker: 'Newsticker',
  no_news: 'Keine News',
  strong_feet: {
    RIGHT: 'Rechts',
    LEFT: 'Links',
    BOTH: 'Beide'
  },
  next_match: 'Nächste Begegnung',
  trainer: 'Trainer',
  stadium: 'Stadion',
  seats: 'Plätze',
  player_info: {
    join_date: 'Im Verein seit',
    jersey_number: 'Rückennummer',
    nationality: 'Nationalität',
    birthday: 'Geburtsdatum',
    age: 'Alter',
    height: 'Größe',
    weight: 'Gewicht',
    strong_feet: 'Starker Fuß'
  },
  general: {
    gameplan_entries: {
      ROUND: 'Runde',
      SEMI_FINALS: 'Halbfinale',
      THIRD_PLACE: 'Spiel um den 3. Platz',
      FIFTH_PLACE: 'Spiel um den 5. Platz',
      SEVENTH_PLACE: 'Spiel um den 7. Platz',
      NINTH_PLACE: 'Spiel um den 9. Platz',
      ELEVENTH_PLACE: 'Spiel um den 11. Platz',
      THIRTEENTH_PLACE: 'Spiel um den 13. Platz',
      FIFTEENTH_PLACE: 'Spiel um den 15. Platz',
      SEVENTEENTH_PLACE: 'Spiel um den 17. Platz',
      NINETEENTH_PLACE: 'Spiel um den 19. Platz',
      TWENTY_FIRST_PLACE: 'Spiel um den 21. Platz',
      TWENTY_THIRD_PLACE: 'Spiel um den 23. Platz',
      FINAL: 'Finale',
      QUARTER_FINALS: 'Viertelfinale',
      ROUND_OF_16: 'Achtelfinale',
      ROUND_OF_32: 'Sechzehntelfinale',
      ROUND_OF_64: 'Runde der letzten 64',
      ROUND_OF_128: 'Runde der letzten 128',
      PLAY_OFFS: 'Play-Offs',
      THIRD_PLACE_PLAY_OFF: 'Playoff Spiel um den 3. Platz',
      QUALIFIER_ROUND: 'Qualifikationsrunde',
      PRACTICE: 'Freies Training',
      PRACTICE_1: '1. Freies Training',
      PRACTICE_2: '2. Freies Training',
      PRACTICE_3: '3. Freies Training',
      PRACTICE_4: '4. Freies Training',
      PRACTICE_5: '5. Freies Training',
      PRACTICE_6: '6. Freies Training',
      PRACTICE_7: '7. Freies Training',
      PRACTICE_8: '8. Freies Training',
      PRACTICE_9: '9. Freies Training',
      QUALIFYING: 'Qualifikationsrunde',
      QUALIFYING_1: '1. Qualifikationsrunde',
      QUALIFYING_2: '2. Qualifikationsrunde',
      QUALIFYING_3: '3. Qualifikationsrunde',
      RACE: 'Rennen',
      RACE_1: '1. Rennen',
      RACE_2: '2. Rennen',
      RACE_3: '3. Rennen',
      RACE_SUPERPOLE: 'Superpole',
      PLACEMENT_QUALIFICATION_MATCH: 'Platzierungs-Qualifikationsspiel',
      EMPTY_PLAYOFF_ROUND_TYPE: 'Finalrunde',
      STAGE_1: '1. Etappe',
      STAGE_2: '2. Etappe',
      STAGE_3: '3. Etappe',
      STAGE_4: '4. Etappe',
      STAGE_5: '5. Etappe',
      STAGE_6: '6. Etappe',
      STAGE_7: '7. Etappe',
      STAGE_8: '8. Etappe',
      STAGE_9: '9. Etappe',
      STAGE_10: '10. Etappe',
      STAGE_11: '11. Etappe',
      STAGE_12: '12. Etappe',
      STAGE_13: '13. Etappe',
      STAGE_14: '14. Etappe',
      STAGE_15: '15. Etappe',
      STAGE_16: '16. Etappe',
      STAGE_17: '17. Etappe',
      STAGE_18: '18. Etappe',
      STAGE_19: '19. Etappe',
      STAGE_20: '20. Etappe',
      STAGE_21: '21. Etappe',
      STAGE_22: '22. Etappe',
      STAGE_23: '23. Etappe',
      STAGE_24: '24. Etappe',
      STAGE_25: '25. Etappe',
      PROLOGUE: 'Prolog'
    }
  },
  motorsport: {
    gameplan_entries: {
      QUALIFYING: 'Qualifying',
      QUALIFYING_1: '1. Qualifying',
      QUALIFYING_2: '2. Qualifying',
      QUALIFYING_3: '3. Qualifying'
    }
  },
  search: {
    popular: 'Beliebt',
    teams: 'Teams',
    players: 'Spieler',
    competitions: 'Wettbewerbe',
    label: 'Team, Wettbewerb oder Spieler suchen',
    input: {
      TEAM: 'Teams durchsuchen',
      PLAYER: 'Spieler durchsuchen',
      COMPETITION: 'Wettbewerbe durchsuchen'
    },
    choose: {
      TEAM: 'Wähle deine Teams:',
      PLAYER: 'Wähle deine Spieler:',
      COMPETITION: 'Wähle deine Ligen und Wettbewerbe:',
      INTEREST: 'Wähle deine Interessen:'
    }
  },
  no_live_games: 'Aktuell keine Live-Spiele',
  settings: {
    TITLE: 'Einstellungen',
    categories: {
      PUSH_MESSAGES: 'Push-Nachrichten verwalten',
      BOOKMARKS: 'Bookmarks',
      faq: 'FAQ',
      IM_FOOTBALL_RECOMMEND: 'iM Football weiterempfehlen',
      IM_FOOTBALL_EVALUATE: 'iM Football bewerten',
      CONTACT: 'Feedback/Kontakt',
      'data-privacy': 'Datenschutz',
      impressum: 'Impressum'
    },
    favorite_types: {
      TITLE: 'Deine Favoriten',
      team: 'Teams',
      player: 'Spieler',
      competition: 'Wettbewerbe',
      interest: 'Interessen',
      GOAL_ALARM: 'Standard-Toralarm'
    },
    interests: {
      BREAKING_NEWS: 'Breaking News',
      GAMING: 'Gaming'
    },
    push_types: {
      TOP_NEWS: 'Top-News',
      LINEUP: 'Aufstellung',
      GAME_START_END: 'An-/Abpfiffe',
      STARTEND_GAME: 'An-/Abpfiffe',
      QUARTER_END: 'Halbzeit',
      GOALS: 'Tore',
      GOAL: 'Tore',
      SENDING_OFF: 'Platzverweise',
      RED_CARD: 'Platzverweise',
      YELLOW_CARDS: 'Gelbe Karten',
      YELLOW_CARD: 'Gelbe Karten',
      SUBSTITUTIONS: 'Auswechslungen',
      TRANSFERS: 'Transfers',
      FINAL_RESULT: 'Endergebnisse',
      FINAL_SCORE: 'Endergebnisse',
      LINEUP_AVAILABLE: 'Aufstellung verfügbar'
    },
    auto_play: {
      WLAN: 'Nur im W-LAN',
      WLAN_AND_MOBILE: 'W-LAN und Mobile Daten',
      OFF: 'Aus'
    },
    privacy: {
      decline: 'Stimme nicht zu',
      accept: 'Annehmen und weiter'
    },
    IM_FOOTBALL_RECOMMEND: {
      message: 'Folge deinen Teams und Spielern. Jetzt für Android und iOS runterladen.',
      title: 'Hol dir die neue iM Football App'
    },
    CONTACT: {
      subject: 'Feedback zur iM Football App',
      body: ''
    }
  },
  nav_bar: {
    feed: 'Für dich',
    news: 'News',
    live: 'Live',
    search: 'Suche'
  },
  onboarding: {
    teams: 'Wähle mindestens ein Team:',
    back: 'Zurück',
    continue: 'Weiter',
    finish: 'Fertig'
  },
  share_text_extern: 'Teilen auf',
  download: 'Jetzt kostenlos herunterladen:',
  empty_message: {
    ARTICLE: 'Es wurden keine Artikel gefunden.',
    CONTENT: 'Es wurden keine Artikel gefunden.',
    FEED: 'Aktuell keine Inhalte vorhanden.',
    GALLERY: 'Es wurden keine Bilder für diese Gallerie gefunden.',
    GAMEPLAN: 'Es wurde kein Spielplan für diesen Wettbewerb gefunden.',
    TEAM_MATCHES: 'Es wurden keine Spiele für dieses Team gefunden.',
    COMPETITION_MATCHES: 'Es wurden keine Spiele für diesen Wettbewerb gefunden.',
    LINEUP: 'Für dieses Spiel gibt es bisher keine Aufstellungen.',
    LIVETICKER: 'Das Spiel hat noch nicht begonnen.',
    CONFERENCETICKER: 'Für diese Spiele steht kein Ticker zur Verfügung.',
    PRE_LIVETICKER: 'Für dieses Spiel gibt es bisher keinen Ticker.',
    PRE_CONFERENCETICKER: 'Für diese Spiele gibt es bisher keinen Ticker.',
    PRE_CONFERENCETICKER_WITH_DATE: 'Der Liveticker startet {{ matchDate }} um {{ matchTime }} Uhr',
    CONFERENCETICKER_NO_MATCHES: 'Am {{ matchDate }} finden keine Spiele statt.',
    MAIN_FEED: 'Wähle weitere Favoriten, um mehr Inhalte zu sehen.',
    MATCH: 'Für dieses Spiel stehen keine Daten zur Verfügung.',
    NEWS: 'Zur Zeit gibt es keine Neuigkeiten.',
    PLAYER: 'Es wurde keine Informationen zu diesem Spieler gefunden.',
    RANKING_ALL: 'Es gibt keine Rankings für diesen Wettbewerb.',
    RANKING_TYPE: 'Es wurden keine Rankings gefunden.',
    SCORE: 'Es wurden keine Spiele gefunden.',
    SCORE_WIDGET: 'Es wurden keine Spiele für deine Favoriten gefunden.',
    SEARCH: 'Keine Ergebnisse gefunden.',
    SQUAD: 'Bisher sind keine Kader zu diesem Team bekannt.',
    STANDINGS: 'Bisher gibt es keine Tabelle für diesen Wettbewerb.',
    STATISTICS: 'Für dieses Spiel gibt es bisher keine Statistiken.',
    TEAM_INFO: 'Es wurden keine Informationen für dieses Team gefunden.',
    TRANSFER: 'Bisher sind keine Transfers bekannt.',
    PLAY_OFFS: 'Bisher gibt es keine Playoffs.'
  },
  pop_up_team_favourited: 'Du hast den Toralarm für eines dieser Teams bereits aktiviert. Bitte passe deine Benachrichtigung in den Einstellungen an.',
  result: {
    after_extra_time: 'n.V.',
    penalty_shootout: 'n.E.'
  },
  feedback_message: 'Wir benutzen zur Bearbeitung dieser Kundenanfragen das Ticketsystem Zendesk, eine Kundenserviceplattform der Zendesk Inc., 989 Market Street %23300, San Francisco, CA 94102. Zendesk ist ein Service aus den USA und ist Privacy Shield zertifiziert https://www.privacyshield.gov/participant?id=a2zt0000000TOjeAAG.\n \nZur Bereitstellung der Services kooperiert die Zendesk Inc. mit weiteren Dienstleistern.\n \n- GoodData Corporation: Die GoodData Coperation („GoodData“) dient als Analyse Provider für die Bereitstellung der Insights. Speicherort: Vereinigte Staaten (Amerika)\n- Smyte, Inc.: Smyte, Inc. ("Smyte") ist ein Anbieter zur Verhinderung von Betrugsfällen.\nZendesk verwendet Smyte um die unrechtmäßige Nutzung abzuwenden. Im Zusammenhang mit der Bereitstellung ihrer Dienste hat Smyte Zugriff auf folgende Datentypen: E-Mail-Adresse des Eigentümers, E-Mail-Adresse des Agenten, E-Mail-Adresse des Endnutzers, IP-Adresse der Eigentümer, Vertreter und Endnutzer, Subdomain des Abonnenten, Fingerabdruck des Geräts, Abonnentenfirma Name, Name des Eigentümers, Telefonnummer des Inhabers, SMS-Überprüfung und Kontoverhalten, z. B. Zeitaufwand für eine Seite, angeklickte Elemente, öffentlich gepostete Inhalte der Hilfe usw. Speicherort: Vereinigte Staaten (Amerika)\n \nAls Datencenter verwendet die Zendesk Inc. folgende Anbieter:\n \n- Equinix, Inc. – Irland, Deutschland\n- Raging Wire Enterprise Solutions, Inc. – Vereinigte Staaten (Amerika)\n \nWenn Sie uns eine Anfrage per Email senden, wird Ihr Name und E-Mail-Adresse ausschließlich für die jeweilige Korrespondenz und Rückantwort mit Ihnen verwendet.\n \nFür die Beantwortung Ihrer Fragen werden folgende Daten erhoben und verarbeitet:\n \n- Empfänger - Email, die verschiedenen Mailserver welche das Email passiert haben, Bericht des SpamServers, Adresse des Empfänger– MailServers, Datum und Uhrzeit der Email, Sender – Email, Betreff, Inhalt der Email\n- Jegliche Art von Anhängen\n \nDie für die Kommunikation mit Ihnen benötigten Daten werden in unterschiedlichen Bereichen verarbeitet:\n \n- Ticket – Daten (Anfrage, Antwort, Kommentare, Schlagwörter, Benutzerdefinierte Felder und Audit Events): Speicherung im europäischen Wirtschaftsraum (EEA) oder Vereinigten Staaten (Amerika)\n- Benutzerdaten (Name, Email): Speicherung im europäischen Wirtschaftsraum (EEA) oder Vereinigten Staaten (Amerika)\n- Attachments (Jegliche Art von Anhängen): Speicherung im europäischen Wirtschaftsraum (EEA) oder Vereinigten Staaten (Amerika)\n- Insights (Anonymisierte und aggregierte Analyse): Speicherung innerhalb der Vereinigten Staaten (Amerika)\n \nBitte beachten Sie, dass bei der Kommunikation mittels E-Mail die Datensicherheit im Internet von Seiten von SPORT1 nicht gewährleistet werden kann und SPORT1 bei der Übersendung von vertraulichen Informationen zur Vorbeugung des Verlustes dieser vertraulichen Informationen den Postweg empfiehlt.\n \nWeitere Informationen finden Sie in unseren Datenschutzbestimmungen: https://www.sport1.de/unternehmen/datenschutz-mobile-imfootball',
  home_feed_end_reached: 'Folge mehr Teams, Spielern und Wettbewerben für weitere Inhalte.',
  end_reached: {
    HOME_FEED: 'Folge mehr Teams, Spielern und Wettbewerben für weitere Inhalte.'
  },
  notification: {
    GOALALARM_ACTIVE: 'Benachrichtigungen aktiv',
    GOALALARM_INACTIVE: 'Benachrichtigungen inaktiv',
    FAV_IN: 'Du folgst jetzt {{ name }}',
    FAV_OUT: 'Du folgst {{ name }} nicht mehr',
    ERROR: 'Du kannst {{name}} zur Zeit nicht folgen',
    TEAM_FAVOURITED: 'Du hast den Toralarm für eines dieser Teams bereits aktiviert. Bitte passe deine Benachrichtigung in den Einstellungen an.'
  },
  transfer: {
    SCREEN_TITLE: 'Transfers',
    SINCE: 'Ab',
    NO_CLUB: 'Vereinslos',
    LOAN: 'Leihe'
  },
  standings_header: {
    TEAM: 'Team',
    PLAYED: 'Sp.',
    WIN: 'S',
    DRAW: 'U',
    LOOSE: 'N',
    GOALS: 'Tore',
    POINTS: 'Pt',
    DIFF: 'Diff.',
    TIME: 'Zeit'
  },
  liveticker: {
    details: 'Telegramm',
    overview: 'Einklappen',
    GOAL: 'Tor',
    PENALTY_GOAL: 'Elfmeter verwandelt',
    PENALTY_WON: 'Elfmeter',
    PENALTY_MISS: 'Elfmeter verschossen',
    PENALTY_SAVED: 'Elfmeter gehalten',
    RED_CARD: 'Rote Karte',
    YELLOW_CARD: 'Gelbe Karte',
    SECOND_YELLOW_CARD: 'Gelb-Rote Karte',
    OWN_GOAL: 'Eigentor',
    SUBSTITUTION: 'Auswechslung',
    VIDEO_REFEREE: 'Videobeweis',
    END: {
      FIRST_HALF: 'Ende 1. Halbzeit',
      FIRST_HALF_STOP: 'Ende 1. Halbzeit',
      SECOND_HALF: 'Ende 2. Halbzeit',
      SECOND_HALF_STOP: 'Ende 2. Halbzeit',
      FIRST_EXTRA_PERIOD: 'Ende 1. Halbzeit Verlängerung',
      FIRST_EXTRA_PERIOD_STOP: 'Ende 1. Halbzeit Verlängerung',
      SECOND_EXTRA_PERIOD: 'Ende 2. Halbzeit Verlängerung',
      SECOND_EXTRA_PERIOD_STOP: 'Ende 2. Halbzeit Verlängerung',
      PENALTY_SHOOTOUT: 'Das Elfmeterschießen ist zu Ende',
      END_OF_MATCH: 'Das Spiel ist zu Ende'
    },
    START: {
      FIRST_HALF: 'Spielbeginn',
      SECOND_HALF: 'Anpfiff 2. Halbzeit',
      FIRST_EXTRA_PERIOD: 'Anpfiff 1. Halbzeit Verlängerung',
      SECOND_EXTRA_PERIOD: 'Anpfiff 2. Halbzeit Verlängerung',
      PENALTY_SHOOTOUT: 'Elfmeterschiessen'
    },
    FULL_TIME: 'Das Spiel ist zu Ende'
  },
  today: 'Heute',
  search_hint: 'Team, Wettbewerb oder Spieler suchen',
  add_favorites_hint: 'Lieblingsteam, Spieler und Wettbewerbe zu den Favoriten hinzufügen',
  download_app_hint: 'Lade dir jetzt die iM Football App herunter und erstelle deinen persönlichen Feed',
  open_app: 'Zur App',
  cancel: 'Abbrechen',
  impressum: 'Impressum',
  data_privacy: 'Datenschutzerklärung',
  search_results: 'Suchergebnisse für:',
  share: {
    standard: 'Hey, schau dir das in der iM Football App an: ',
    ticker: '{{ homeTeam }} - {{ awayTeam }} im iM Football Ticker'
  },
  default_ad_label: 'Jetzt ansehen',
  inactive: 'Inaktiv',
  referee: 'Schiedsrichter'
};
exports.default = _default;